import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-add-cp-payment',
    templateUrl: './add-cp-payment.component.html',
    styleUrls: ['./add-cp-payment.component.scss'],
    standalone: false
})
export class AddCpPaymentComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  selectedAccountId: number;

  @Input() selectedProfileId: number;
  @Input() isModal = true;

  @Output() passEntry = new EventEmitter<any>();
  //2-WAY BINDING INFO
  paymentDate: Date = new Date();
  remark: string;
  amount = 0;

  disabledSubmit = false;

  ngOnInit(): void {
    const loggedInCompanyId = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(loggedInCompanyId);
  }

  private getAllAccountsOfCompany(companyId: number) {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/company/"+companyId+"/accounts";
    // xhttp.withCredentials = true;
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else if (account.Username == loggedInUsername)
            this.cashAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined);
    const paymentValid = isNaN(+this.amount);

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid
  }

  addPaymentForBadDebt() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.paymentDate))).toISOString();

    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getPayProfileBadDebt(this.selectedProfileId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);

          this.passEntry.emit(this.selectedProfileId)
          this.reset();
          this.sharedService.openAlert("Successfully added payment for bad debt!", ALERT_TYPE.SUCCESS);
        } else this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  submit() {
    (this.isFieldNull()) ? this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER) : this.addPaymentForBadDebt();
  }

  reset() {
    this.activeModal.close();
  }
}
